module.exports = __webpack_public_path__ + "static/media/egg_haibao_zhuli.4ee3fed8.png";